import {useMemo} from 'react';
import {useWindowDimensions} from "react-native";

export const SCREEN_WIDTH_DESKTOP = {
    min: 761,
    max: null,
}

/**
 * mobile responsive layouts are kind of all over the place.
 * This probably won't be appropriate for all cases
 */
export const SCREEN_WIDTH_MOBILE = {
    min: 0,
    max: 760,
}

export function useDimensions() {
    const {width, height} = useWindowDimensions();

    const isMobile = useMemo(() => {
        return width <= SCREEN_WIDTH_MOBILE.max;
    }, [width])

    return {
        width,
        height,
        isMobile,
    };
}
